<!--首页-->
<template>
	<div class="page-body">
		<top :data="topData"></top>
		<noticeScrollX ref="noticeScrollXRef"></noticeScrollX>
		<div class="center-wrap">
			<model1 :data="model1Data"></model1>
			<!-- <model2></model2> -->
			<model3 :data="model3Data"></model3>
			<model4 :data="model4Data"></model4>
			<model5 :data="model5Data" :img="homeData.kline_image"></model5>
			<model6 :data="model6Data"></model6>
			<!-- <model7></model7>
			<model8></model8>
			<model9></model9>
			<model10></model10> -->
		</div>
	</div>
</template>
<script>
import { get } from '@/http/request'

import top from './components/top.vue';
import noticeScrollX from './components/noticeScrollX.vue';
import model1 from './components/model1.vue';
// import model2 from './components/model2.vue';
import model3 from './components/model3.vue';
import model4 from './components/model4.vue';
import model5 from './components/model5.vue';
import model6 from './components/model6.vue';
// import model7 from './components/model7.vue';
// import model8 from './components/model8.vue';
// import model9 from './components/model9.vue';
// import model10 from './components/model10.vue';
export default {
	components: {
		top,
		noticeScrollX,
		model1,
		// model2,
		model3,
		model4,
		model5,
		model6,
		// model7,
		// model8,
		// model9,
		// model10,
	},
	data() {
		return {
			homeData: {},
		};
	},
	created() {
		this.getIndexData()
	},
	computed: {
		topData() {
			return {
				"money_count": this.homeData.money_count,
				"coin_count": this.homeData.coin_count,
				"user_count": this.homeData.user_count,
				...this.homeData.intro
			}
		},
		model1Data() {
			return this.homeData.notice
		},
		model3Data() {
			return this.homeData.quantAi
		},
		model4Data() {
			return this.homeData.product
		},
		model5Data() {
			return this.homeData.product
		},
		model6Data() {
			return this.homeData.quantCombine
		},
	},
	beforeUnmount() { },
	methods: {
		getIndexData() {
			get(this.$apis.getIndexData, {}).then(res => {
				// console.log(res)
				if (res.code != 1) return
				this.homeData = res.data

				if (Array.isArray(this.homeData.priceData) && this.homeData.priceData.length > 0) {
					this.$refs.noticeScrollXRef.init(this.homeData.priceData)
				} 
			})
		}
	},
};
</script>
<style lang="scss" scoped>
.page-body {}
</style>